var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityReception = function SvgFacilityReception(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40-442v-394h215v57l311-89 314 96v137H668v73L349-442H40Zm60-60h94v-274h-94v274Zm155 0h84l265-101v-32h-77l-115 38-22-58 129-40h299v-33l-256-78-307 90v214ZM400-80h520v-60H400v60Zm40-120h440q0-81-51.5-141.5T700-415.823V-480h-80v64.177Q542-402 491-341.5 440-281 440-200Zm71-60q18-44 58-72t91.211-28Q710-360 750-332t58 72H511Zm149 0Z"
  })));
};
export default SvgFacilityReception;